import React from 'react';
import { PropTypes } from 'prop-types';

import { Field } from '@ontruck/orc';

import DatePickerCalendar from 'components/form/DatePickerCalendar';
import ResponsiveModal from 'components/ResponsiveModal';
import useFormState from 'hooks/useFormState';

const DateField = ({
  className,
  value,
  extraClassName,
  responsiveModalRef,
  t,
  handleChange,
  type,
  minDate,
  maxDate,
  hasError,
}) => {
  const field = `date_field`;
  const stopId = `recurring-${type}`;
  const { fieldHasError } = useFormState(stopId, field, value);
  const errorClassName = !!hasError || fieldHasError ? 'error' : 'not-error';

  return (
    <div className={`${className} ${extraClassName} `}>
      <ResponsiveModal
        modalRef={responsiveModalRef}
        refProperty="fieldRef"
        footer={t('footer')}
        alignRight={type === 'end_on'}
        content={
          <DatePickerCalendar
            minDate={minDate}
            maxDate={maxDate}
            handleChange={handleChange}
          />
        }
      >
        <Field
          type="text"
          className={errorClassName}
          id={type}
          name={type}
          value={value}
          label={t(`form.label_${type}`)}
          size="L"
          fullWidth
          readOnly
          invalid={!!hasError}
        />
      </ResponsiveModal>
    </div>
  );
};

DateField.propTypes = {
  t: PropTypes.func,
  className: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  extraClassName: PropTypes.string,
  handleChange: PropTypes.func,

  responsiveModalRef: PropTypes.func,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  hasError: PropTypes.bool,
};

DateField.defaultProps = {
  t: () => {},
  className: '',
  type: '',
  value: '',
  extraClassName: '',
  handleChange: () => ({}),

  responsiveModalRef: () => ({}),
  minDate: undefined,
  maxDate: undefined,
  hasError: false,
};

export default DateField;
